/**
 * @file Header displayed in landing pages (completely void of links).
 */

import React from 'react';

import Header from './Header';
import Logo from './Logo';
import NavBar from './NavBar';
import LogoutLink from '../auth/LogoutLink';

const HeaderLanding = () => (
  <Header>
    <div className="site-brand">
      <Logo linksTo="/app" />
    </div>

    <NavBar>
      <ul className="navbar-nav">
        <li className="nav-item">
          <LogoutLink className="nav-link" />
        </li>
      </ul>
    </NavBar>
  </Header>
);

export default HeaderLanding;
